<div class="sidebar-main">
  <div class="logo-section flex w-full justify-around items-center">
    <h1 class="large-text">Bingo</h1>
    <button class="lg:hidden" (click)="menu_toggle()" style="width: 24px; height: 24px">
      <img src="../../../../assets/Icons/close.svg" />
    </button>
  </div>
  <div class="flex flex-col gap-8 pt-6 max-xs:gap-12 max-xxs:px-6">
    <!-- Dashboard -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['Dashboard']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/dashboard.svg" />
        </span>
        <span class="sidebar-text">Dashboard</span>
      </div>
    </button>
    <!-- Bingo Card -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['Bingo-cards']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/bingo-cards.svg" />
        </span>
        <span class="sidebar-text">Bingo Cards</span>
      </div>
    </button>
    <!-- Fun activity card -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['fun-activity-cards']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/bingo-cards.svg" />
        </span>
        <span class="sidebar-text">Fun Activity Cards</span>
      </div>
    </button>
    <!-- Quest -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['quest-card']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/bingo-cards.svg" />
        </span>
        <span class="sidebar-text">Quest</span>
      </div>
    </button>
    <!-- Patches -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['patches']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/bingo-cards.svg" />
        </span>
        <span class="sidebar-text">Patches</span>
      </div>
    </button>
    <!-- Offer -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['offer']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/bingo-cards.svg" />
        </span>
        <span class="sidebar-text">Offer</span>
      </div>
    </button>
    <!-- Event List -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['event-list']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/event.svg" />
        </span>
        <span class="sidebar-text">Event List</span>
      </div>
    </button>
    <!-- Guide Request List -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['guide-request']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/user-circle-single.svg" />
        </span>
        <span class="sidebar-text">Guide Request</span>
      </div>
    </button>
    <!-- Guide List -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['guide-list']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/user-circle-single.svg" />
        </span>
        <span class="sidebar-text">Guide List</span>
      </div>
    </button>
    <!-- Offline Checkin -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['offline-checkin']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/check-in.svg" />
        </span>
        <span class="sidebar-text">Offline Check-in</span>
      </div>
    </button>
    <!-- Categories -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['categories']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/category.svg" />
        </span>
        <span class="sidebar-text">Categories</span>
      </div>
    </button>
    <!-- User List -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['User-list']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/user-circle-single.svg" />
        </span>
        <span class="sidebar-text">Users List</span>
      </div>
    </button>
    <!-- Push Notification -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['push-notification']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/notification.svg" />
        </span>
        <span class="sidebar-text">Push Notification</span>
      </div>
    </button>
    <!-- Account Delete -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['account-delete']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/user-delete-admin.svg" />
        </span>
        <span class="sidebar-text">Account Delete</span>
      </div>
    </button>
    <!-- App versions -->
    <button class="sidebar-btn w-full flex items-center justify-center">
      <div class="sidebar-menu flex items-center gap-4 py-2 pl-4" routerLinkActive="router-link-active"
        [routerLink]="['app-version-list']" (click)="closeSidebar()">
        <span class="sidebar-icon flex items-center justify-center">
          <img class="w-full h-full" src="../../../../assets/Icons/version.svg" />
        </span>
        <span class="sidebar-text">App Version</span>
      </div>
    </button>
  </div>
</div>